import { defineStore } from "pinia";
import { ref } from "vue";
import { useProfilesStore } from "./profiles";

export const useUserPresenceStore = defineStore("userPresence", () => {
  const profilesStore = useProfilesStore();
  const onlineUsers = ref([]);
  const dialogRooms = ref({});
  /**
   * Updates the list of online user ids.
   *
   * @param {Array} usersIds - The list of online user ids.
   * @return {void} This function does not return a value.
   */
  const setOnlineUsersIds = (usersIds) => {
    onlineUsers.value = usersIds.map(Number); // converting all ids to numbers since we
  };

  const addOnlineUserId = (userId) => onlineUsers.value.push(userId);
  const removeOnlineUserId = (userId) => {
    onlineUsers.value = onlineUsers.value.filter((id) => id !== userId);
    profilesStore.updateProfileByUserId(userId, { last_seen_at: new Date() });
  };

  const isUserOnline = (userId) => onlineUsers.value.includes(userId);

  const isBothOnline = (userId1, userId2) =>
    isUserOnline(userId1) && isUserOnline(userId2);

  const isUserPresenceListenerInitialized = ref(false);

  return {
    onlineUsers,
    setOnlineUsersIds,
    isUserPresenceListenerInitialized,
    addOnlineUserId,
    removeOnlineUserId,
    isUserOnline,
    isBothOnline,
  };
});
